import React from 'react';
import UilUser from '@iconscout/react-unicons/icons/uil-user';
import UilUserPlus from '@iconscout/react-unicons/icons/uil-user-plus';
import UilUserMinus from '@iconscout/react-unicons/icons/uil-user-minus';
import UilUserTimes from '@iconscout/react-unicons/icons/uil-user-times';
import UilUserCheck from '@iconscout/react-unicons/icons/uil-user-check';
import UilUserExclamation from '@iconscout/react-unicons/icons/uil-user-exclamation';
import UilBell from '@iconscout/react-unicons/icons/uil-bell';
import UilSetting from '@iconscout/react-unicons/icons/uil-setting';
import UilSync from '@iconscout/react-unicons/icons/uil-sync';
import UilBuilding from '@iconscout/react-unicons/icons/uil-building';
import UilChart from '@iconscout/react-unicons/icons/uil-chart';
import UilProcessor from '@iconscout/react-unicons/icons/uil-processor';
import UilCog from '@iconscout/react-unicons/icons/uil-cog';
import UilAngleDown from '@iconscout/react-unicons/icons/uil-angle-down';
import UilAngleUp from '@iconscout/react-unicons/icons/uil-angle-up';
import UilArrowLeft from '@iconscout/react-unicons/icons/uil-arrow-left';
import UilArrowRight from '@iconscout/react-unicons/icons/uil-arrow-right';
import UilArrowUp from '@iconscout/react-unicons/icons/uil-arrow-up';
import UilArrowDown from '@iconscout/react-unicons/icons/uil-arrow-down';
import UilCheckCircle from '@iconscout/react-unicons/icons/uil-check-circle';
import UilTimesCircle from '@iconscout/react-unicons/icons/uil-times-circle';
import UilExclamationCircle from '@iconscout/react-unicons/icons/uil-exclamation-circle';
import UilArrowCircleUp from '@iconscout/react-unicons/icons/uil-arrow-circle-up';
import UilUsersAlt from '@iconscout/react-unicons/icons/uil-users-alt';
import UilGraduationCap from '@iconscout/react-unicons/icons/uil-graduation-cap';
import UilFileAlt from '@iconscout/react-unicons/icons/uil-file-alt';
import UilFolderOpen from '@iconscout/react-unicons/icons/uil-folder-open';
import UilExport from '@iconscout/react-unicons/icons/uil-export';
import UilImport from '@iconscout/react-unicons/icons/uil-import';
import UilRobot from '@iconscout/react-unicons/icons/uil-robot';
import UilCalendarAlt from '@iconscout/react-unicons/icons/uil-calendar-alt';
import UilCalendar from '@iconscout/react-unicons/icons/uil-calendar';
import UilLock from '@iconscout/react-unicons/icons/uil-lock';
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import UilAngleLeft from '@iconscout/react-unicons/icons/uil-angle-left';
import UilAngleRight from '@iconscout/react-unicons/icons/uil-angle-right';
import UilBars from '@iconscout/react-unicons/icons/uil-bars';
import UilFileInfoAlt from '@iconscout/react-unicons/icons/uil-file-info-alt';
import UilClockThree from '@iconscout/react-unicons/icons/uil-clock-three';
import UilLayers from '@iconscout/react-unicons/icons/uil-layers';
import UilEye from '@iconscout/react-unicons/icons/uil-eye';
import UilEyeSlash from '@iconscout/react-unicons/icons/uil-eye-slash';
import UilSignout from '@iconscout/react-unicons/icons/uil-signout';
import UilHome from '@iconscout/react-unicons/icons/uil-home';
import UilTimes from '@iconscout/react-unicons/icons/uil-times';
import UilExclamationTriangle from '@iconscout/react-unicons/icons/uil-exclamation-triangle';
import UilInfoCircle from '@iconscout/react-unicons/icons/uil-info-circle';
import UilAwardAlt from '@iconscout/react-unicons/icons/uil-award-alt';
import UilPlus from '@iconscout/react-unicons/icons/uil-plus';
import UilMinus from '@iconscout/react-unicons/icons/uil-minus';
import UilEllipsisH from '@iconscout/react-unicons/icons/uil-ellipsis-h';
import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import UilFilter from '@iconscout/react-unicons/icons/uil-filter';
import UilSpinnerAlt from '@iconscout/react-unicons/icons/uil-spinner-alt';
import UilCheck from '@iconscout/react-unicons/icons/uil-check';
import UilEdit from '@iconscout/react-unicons/icons/uil-edit';
import UilEditAlt from '@iconscout/react-unicons/icons/uil-edit-alt';
import UilPen from '@iconscout/react-unicons/icons/uil-pen';
import UilCopy from '@iconscout/react-unicons/icons/uil-copy';
import UilTable from '@iconscout/react-unicons/icons/uil-table';
import UilDocumentInfo from '@iconscout/react-unicons/icons/uil-document-info';
import UilQuestionCircle from '@iconscout/react-unicons/icons/uil-question-circle';
import UilExternalLinkAlt from '@iconscout/react-unicons/icons/uil-external-link-alt';
import UilEnvelope from '@iconscout/react-unicons/icons/uil-envelope';
import UilMessage from '@iconscout/react-unicons/icons/uil-message';
import UilCalculatorAlt from '@iconscout/react-unicons/icons/uil-calculator-alt';
import UilBan from '@iconscout/react-unicons/icons/uil-ban';
import UilTrashAlt from '@iconscout/react-unicons/icons/uil-trash-alt';


const ICONS = {
  angleDown: UilAngleDown,
  angleUp: UilAngleUp,
  angleLeft: UilAngleLeft,
  angleRight: UilAngleRight,
  arrowLeft: UilArrowLeft,
  arrowRight: UilArrowRight,
  arrowUp: UilArrowUp,
  arrowDown: UilArrowDown,
  ban: UilBan,
  bars: UilBars,
  bell: UilBell,
  building: UilBuilding,
  calculator: UilCalculatorAlt,
  calendarAlt: UilCalendarAlt,
  calendar: UilCalendar,
  chart: UilChart,
  check: UilCheck,
  checkCircle: UilCheckCircle,
  timesCircle: UilTimesCircle,
  exclamationCircle: UilExclamationCircle,
  arrowCircleUp: UilArrowCircleUp,
  clockThree: UilClockThree,
  cog: UilCog,
  copy: UilCopy,
  documentInfo: UilDocumentInfo,
  edit: UilEdit,
  editAlt: UilEditAlt,
  pen: UilPen,
  envelope: UilEnvelope,
  export: UilExport,
  eye: UilEye,
  eyeSlash: UilEyeSlash,
  fileAlt: UilFileAlt,
  fileInfo: UilFileInfoAlt,
  folderOpen: UilFolderOpen,
  table: UilTable,
  graduationCap: UilGraduationCap,
  home: UilHome,
  import: UilImport,
  close: UilTimes,
  alert: UilExclamationTriangle,
  awardAlt: UilAwardAlt,
  info: UilInfoCircle,
  questionCircle: UilQuestionCircle,
  externalLink: UilExternalLinkAlt,
  plus: UilPlus,
  minus: UilMinus,
  more: UilEllipsisH,
  moreVertical: UilEllipsisV,
  paperPlane: UilMessage,
  filter: UilFilter,
  layers: UilLayers,
  lock: UilLock,
  processor: UilProcessor,
  robot: UilRobot,
  search: UilSearch,
  setting: UilSetting,
  signout: UilSignout,
  spinnerAlt: UilSpinnerAlt,
  sync: UilSync,
  trash: UilTrashAlt,
  user: UilUser,
  userPlus: UilUserPlus,
  userMinus: UilUserMinus,
  userTimes: UilUserTimes,
  userCheck: UilUserCheck,
  userExclamation: UilUserExclamation,
  usersAlt: UilUsersAlt,
} as const;

export type IconScoutName = keyof typeof ICONS;

export type IconScoutSizeToken = number | 'sm' | 'md' | 'lg' | 'xl';
const SIZE_MAP: Record<string, number> = {
  sm: 16,
  md: 20,
  lg: 24,
  xl: 40,
};

const DEFAULT_SIZE = 16;
const DEFAULT_COLOR = 'currentColor';

export interface IconScoutProps {
  name: IconScoutName;
  size?: IconScoutSizeToken;
  color?: string;
  className?: string;
  'data-testid'?: string;
}

export const IconScout: React.FC<IconScoutProps> = ({
  name,
  size = DEFAULT_SIZE,
  color = DEFAULT_COLOR,
  className,
  'data-testid': dataTestId,
}) => {
  const Component = ICONS[name];
  const resolvedSize = typeof size === 'string' ? (SIZE_MAP[size] ?? DEFAULT_SIZE) : size;
  return (
    <Component
      size={resolvedSize}
      color={color}
      className={className}
      data-testid={dataTestId ?? `icon-${name}`}
    />
  );
};

export const iconScoutNames = Object.keys(ICONS) as IconScoutName[];
